import { ButtonLink } from 'braid-design-system';
import React from 'react';
import { prefixUrlWithLanguage } from '../../helpers/prefixUrlWithLanguage';

type Props = {
  name: string;
  slug: string;
  basePath: string;
  locale?: string;
};

const CategoryLink = ({ name, slug, basePath, locale }: Props) => {
  const categoryLinkWithLocale = prefixUrlWithLanguage({
    url: `/${basePath}/category/${slug}`,
    locale,
  });

  return (
    <ButtonLink href={categoryLinkWithLocale} variant="soft">
      {name}
    </ButtonLink>
  );
};

export { CategoryLink };
